import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('adminToken') || localStorage.getItem('spoleto_admin_auth');
    if (!token) {
      navigate('/spoleto', { replace: true });
    } else {
      setAuthorized(true);
    }
  }, [navigate]);

  if (!authorized) return null;
  return children;
}
